module.exports = __webpack_public_path__ + "img/simplybuilt.65ef1ee5.svg";